module.exports = __webpack_public_path__ + "img/count_minus.fea31200.svg";